import {
    AUTH_LOGIN,
    STORE_TOKEN,
    REGISTER_USER,
    AUTH_LOGOUT, GET_USERS, STORE_USERS, UPDATE_USER_INFO,
    REFRESH_USER_INFO,
} from '../../constants/auth';

export const authLogin = (username, password, history) => ({
    type: AUTH_LOGIN,
    username,
    password,
    history,
});

export const storeToken = (token, userInfo ) => ({
    type: STORE_TOKEN,
    token,
    userInfo,
    isAuthenticated: true
});

export const registerUser = (newUser,callback) => ({
    type: REGISTER_USER,
    newUser,
    callback
});

export const authLogout = (history) => ({
    type: AUTH_LOGOUT,
    history,
});

export const getUsers = () => ({
    type: GET_USERS
})

export const storeUsers = (users) => ({
    type: STORE_USERS,
    users
})

export const updateUserInfo = (userInfo) => ({
    type: UPDATE_USER_INFO,
    userInfo
})

// Pulls a fresh copy of the current user's info from the server and
// merges it into Redux. Used to apply permission/role changes without
// requiring a logout/login round-trip.
export const refreshUserInfo = () => ({
    type: REFRESH_USER_INFO,
})
